import React, {Component} from 'react'
import {Checkbox, Popup} from 'semantic-ui-react'

class SelectAll extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    let {selectAll, allSelected} = this.props
    return (
      <div style={{marginTop: '7px', marginLeft: '6px'}}>
        <Popup content='Select all' position='right center'
          trigger={
            <Checkbox onChange={selectAll} style={{zoom: '150%'}}
              checked={allSelected}
            />
          }
        />

      </div>
    )
  }
}

export default SelectAll
